exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.statistics-overlay[data-v-47338832] {\n  position: fixed;\n  top: 90px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(30, 30, 30, 0.6);\n}\n.statistics-container[data-v-47338832] {\n  background-color: white;\n  border-radius: 10px;\n  margin: 10px;\n  padding: 30px 20px;\n  -webkit-box-shadow: 0 0 5px #1E1E1E;\n          box-shadow: 0 0 5px #1E1E1E;\n}\n.danger[data-v-47338832] {\n  background-color: rgba(255, 50, 100, 0.5)!important;\n}\n.users[data-v-47338832] {\n  text-align: right;\n  margin-top: 20px;\n}\n.pointer[data-v-47338832] {\n  cursor: pointer;\n}\n.search-box[data-v-47338832] {\n  width: 250px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47338832","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/service/administration/users/UserList.vue
// module id = g3hf
// module chunks = 53